import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

/**
 * Layer-1 container (guide 6.3): surface color, hairline border, 12px radius,
 * no shadow. Elevation comes from the tone step against the canvas.
 */
export const Surface = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'padding',
})<{ padding?: number }>(({ theme, padding }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: `${theme.palette.tokens.radius.card}px`,
  padding: padding ?? theme.palette.tokens.space[6],
}));

/** Surface whose only content is a table: no inner padding, clipped corners. */
export const TableSurface = styled(Surface)(() => ({
  padding: 0,
  overflow: 'hidden',
}));

/** Vertical rhythm between page blocks: state → movement → table → alerts. */
export const PageStack = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.palette.tokens.space[10],
}));
